import React from 'react';

import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';
import runIcon from 'images/icons/invite/play.svg';

import { Link } from 'react-router-dom';

import routes from 'app/routes';

import actions from '../../Actions';

export default function RowActions({ enterpriseId, row, onDelete }) {
  const onDeleteClick = (e, row) => {
    swal(
      {
        title: '',
        text: 'Do you want to delete this brief?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.delete(row.id, () => {
            onDelete();
          });
        }
      },
    );
  };

  return (
    <div>
      <Link
        to={routes.admin.enterprise_briefs.edit(enterpriseId, row.id)}
        className="mr10"
      >
        <img src={editIcon} alt="edit" />
      </Link>

      <a onClick={(e) => onDeleteClick(e, row)}>
        <img src={deleteIcon} />
      </a>
    </div>
  );
}
